import { History } from "history";

import { AppToaster } from "@components";
import { OrgData } from "@types";

import { deletePolicy, fetchPolicy } from "../api";
import { Policy, PolicyWithRules } from "../types";

const isRunningOnRepos = async (_: unknown, policyToDelete: Policy) => {
  return policyToDelete.repos.length > 0;
};

/**
 * Deletes a policy from the backend
 */
export const onDeletePolicy =
  (
    org: OrgData,
    history: History,
    policy: PolicyWithRules,
    refreshPolicies: () => void
  ) =>
  async () => {
    const policyName = policy.name;
    const slugToDelete = policy.slug;
    let policyToDelete;
    try {
      policyToDelete = (await fetchPolicy(org.id, slugToDelete)).policy;
    } catch (err) {
      AppToaster.show({
        message: `Could not find policy: ${policyName}`,
        intent: "danger",
      });
      return;
    }
    try {
      let isLocked = await isRunningOnRepos(org, policyToDelete);
      if (isLocked) {
        throw new Error(`Cannot delete "${policyName}": policy is in use`);
      }
    } catch (e) {
      console.warn(e);
      if (e instanceof Error) {
        AppToaster.show({
          message: e.message,
          intent: "danger",
        });
      }
      return;
    }
    deletePolicy(org.id, policyToDelete)
      .then(() => {
        AppToaster.show({
          message: `Deleted policy '${policyName}'`,
          intent: "success",
        });
        if (policy?.name === policyName) {
          history.push(`/manage/policies`);
        }
        refreshPolicies();
      })
      .catch((err) => {
        AppToaster.show({
          message: `Cannot delete "${policyName}": ${err.body?.error}`,
          intent: "danger",
        });
      });
  };
